export default __webpack_public_path__ + "static/media/1297.40a704a5.png";